<template>
  <div v-if='this.$config["Html With Markdown"].UserPrivacy' v-html="compiledMarkdown"></div>
  <div v-else class="content">
    <h1>{{ this.$config["Product Name"] }}隐私政策</h1>
    <div style='text-align:center'>
      <span style='font-size:0.6rem'>(v1.0.0)</span>
    </div>
    <p>
      更新日期：2019年08月26日<br>
      生效日期：2019年08月26日<br>
    </p>
    <p>
      <strong>
        引言:<br>
      </strong>
      &emsp;&emsp;{{ this.$config["Product Name"] }}严格遵守法律法规，遵循以下隐私保护原则，为您提供更加安全、可靠的服务：<br>
      （1）安全可靠：我们竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失；<br>
      （2）自主选择：我们为您提供便利的信息管理选项，以便您做出合适的选择，管理您的个人信息；<br>
      （3）保护通信秘密： 我们严格遵照法律法规，保护您的通信秘密，为您提供安全的通信服务；<br>
      （4）合理必要：为了向您和其他用户提供更好的服务，我们仅收集必要的信息；<br>
      （5）清晰透明：我们努力使用简明易懂的表述，向您介绍隐私政策，以便您清晰地了解我们的信息处理方式；<br>
      （6）将隐私保护融入产品设计：我们在产品或服务开发的各个环节，综合法律、产品、设计等多方因素，融入隐私保护的理念。
    </p>
    <p>
      <strong>
        本《隐私政策》主要向您说明：<br>
      </strong>
      一、我们收集的信息；<br>
      二、我们在您使用服务时获取的信息；<br>
      三、我们如何使用收集的信息；<br>
      四、我们如何使用Cookie及相关技术；<br>
      五、您分享的信息；<br>
      六、您如何管理自己的信息；<br>
      七、我们分享的信息；<br>
      八、我们可能基于以下目的披露您的个人信息；<br>
      九、我们可能向您发送的信息；<br>
      十、存储信息的地点和期限；<br>
      十一、信息安全；<br>
      十二、联系我们。<br>
      &emsp;&emsp;希望您仔细阅读《隐私政策》（以下简称“本政策”），详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并作出适当的选择。若您使用{{
        this.$config["Product Name"]
      }}服务，即表示您认同我们在本政策中所述内容。


    </p>
    <h2>
      一、我们收集的信息
    </h2>
    <p>
      &emsp;&emsp;我们根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息。<br>
      &emsp;&emsp;您在使用我们服务时主动提供的信息：<br>
      （1）您在注册帐户时填写的信息<br>
      &emsp;&emsp;例如，您在注册{{ this.$config["Product Name"] }}帐户时所填写的昵称、手机号码、授权登录方式下微信或QQ所授权的如昵称等必要信息。<br>
      （2）您在使用服务时上传的信息<br>
      &emsp;&emsp;例如，您在使用{{ this.$config["Product Name"] }}时，上传的头像、上传的图片、上传的微信昵称、用户名、手机号、身份认证等相关信息。<br>
      （3）您通过我们的客服或参加我们举办的活动时所提交的信息<br>
      &emsp;&emsp;例如，您参与我们线上活动时填写的调查问卷中可能包含您的姓名、电话、地址等信息。<br>

      &emsp;&emsp;我们的部分服务可能需要您提供特定的个人敏感信息来实现特定功能。若您选择不提供该类信息，则可能无法正常使用服务中的特定功能，但不影响您使用服务中的其他功能。若您主动提供您的个人敏感信息，即表示您同意我们按本政策所述目的和方式来处理您的个人敏感信息。

    </p>
    <h2>
      二、我们在您使用服务时获取的信息
    </h2>
    <p>
      （1）手机设备状态信息<br>
      &emsp;&emsp;例如，设备型号、操作系统版本、唯一设备标识符等信息。<br>
      （2）软件信息<br>
      &emsp;&emsp;例如，软件的版本号、浏览器类型。为确保操作环境的安全或提供服务所需，我们会收集有关您使用的移动应用和其他软件的信息。<br>
      （3）IP地址<br>
      &emsp;&emsp;例如，您在使用我们服务时用于识别设备连接至互联网服务时所在的位置信息。<br>
      （4）服务日志信息<br>
      &emsp;&emsp;例如，您在使用我们服务时搜索、查看的信息、服务故障信息、引荐网址等信息。<br>
      （5）应用使用信息<br>
      &emsp;&emsp;例如，在使用我们服务其他产品访问顺序、时间、名称等信息。<br>
      （6）应用内安装其他应用的信息<br>
      &emsp;&emsp;我们可能会获得您在使用我们服务时安装其他产品的相关信息。<br>
      （7）悬浮窗使用信息<br>
      &emsp;&emsp;例如，在使用我们服务时更便捷完成指定操作行为的信息。<br>
      （8）相机使用信息<br>
      &emsp;&emsp;基于摄像头（相机）的附加功能：您可以在开启相机/摄像头权限后使用这个附加功能，完成拍照、扫码以及特定场景下如通过UDESK客服反馈问题等信息。<br>
      （9）麦克风使用信息<br>
      &emsp;&emsp;基于麦克风的附加功能：您可以在开启麦克风权限后使用这个附加功能，完成语音录制如通过UDESK客服反馈问题等信息。<br>
      （10）位置信息<br>
      &emsp;&emsp;当您使用与位置有关的服务时，我们可能会记录您设备所在的位置信息，以便为您提供相关服务。在您使用服务时，我们可能会通过IP地址、GPS、WLAN（如
      WiFi)或基站等途径获取您的地理位置信息；您或其他用户在使用服务时提供的信息中可能包含您所在地理位置信息，例如您提供的帐号信息中可能包含的您所在地区信息，您或其他人共享的照片包含的地理标记信息。<br>
      （11）其他相关信息<br>
      &emsp;&emsp;为了帮助您更好地使用我们的产品或服务，我们会收集相关信息。例如您在安装{{
        this.$config["Product Name"]
      }}软件时，会读取和修改您的SD卡信息；您在注册账号时，需要读取您的短信信息等。<br>
      （12）其他用户分享的信息中含有您的信息<br>
      &emsp;&emsp;例如，其他用户发布的图片或填写的信息中可能包含您的信息。<br>
      （13）从第三方合作伙伴获取的信息<br>
      &emsp;&emsp;我们可能会获得您在使用第三方合作伙伴服务时所产生或分享的信息。例如，您使用{{
        this.$config["Product Name"]
      }}帐户登录第三方合作伙伴服务时，我们会获得您登录第三方合作伙伴服务的名称、登录时间，方便您进行授权管理。

    </p>
    <h2>
      三、我们如何使用收集的信息
    </h2>
    <p>
      &emsp;&emsp;我们严格遵守法律法规的规定及与用户的约定，将收集的信息用于以下用途。若我们超出以下用途使用您的信息，我们将再次向您进行说明，并征得您的同意。<br>
      （1）向您提供服务<br>
      （2）满足您的个性化需求<br>
      &emsp;&emsp;例如，头像及性别设定、个性化的设置及帮助服务。<br>
      （3）产品开发和服务优化<br>
      &emsp;&emsp;例如，当我们的系统发生故障时，我们会记录和分析系统故障时产生的信息，优化我们的服务。<br>
      （4）安全保障<br>
      &emsp;&emsp;例如，我们会将您的信息用于身份验证、安全防范、反诈骗监测、存档备份、客户的安全服务等用途。例如，您下载或安装的安全软件会对恶意程序或病毒进行检测，或为您识别诈骗信息。<br>
      （5）向您推荐您可能感兴趣的广告、资讯等<br>
      （6）评估、改善我们的广告投放和其他促销及推广活动的效果<br>
      （7）管理软件<br>
      &emsp;&emsp;例如，进行软件认证、软件升级等。<br>
      （8）邀请您参与有关我们服务的调查<br>
      &emsp;&emsp;为了让您有更好的体验、改善我们的服务或经您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某些服务所收集的信息用于我们的其他服务。例如，将您在使用我们某项服务时的信息，用于另一项服务中向您展示个性化的内容或广告、用于用户研究分析与统计等服务。<br>
      &emsp;&emsp;为了确保服务的安全，帮助我们更好地了解我们应用程序的运行情况，我们可能记录相关信息，例如，您使用应用程序的频率、故障信息、总体使用情况、性能数据以及应用程序的来源。我们不会将我们存储在分析软件中的信息与您在应用程序中提供的个人身份信息相结合。
    </p>
    <h2>
      四、我们如何使用Cookie及相关技术
    </h2>
    <p>
      （1）我们或我们的第三方合作伙伴，可能通过放置安全的Cookie及相关技术收集您的信息，目的是为您提供更个性化的用户体验和服务。我们会严格要求第三方合作伙伴遵守本政策的相关规定。<br>
      （2）您也可以通过浏览器设置管理Cookie。但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。
    </p>
    <h2>
      五、您分享的信息
    </h2>
    <p>
      （1）您可以通过我们的服务与您的好友、家人及其他用户分享您的相关信息。例如，您在微信朋友圈中公开分享的文字和照片。（<span style="color: red">请注意，这其中可能包含您的个人身份信息、个人财产信息等敏感信息。请您谨慎考虑披露您的相关个人敏感信息。</span>）<br>
      （2）您可通过我们服务中的设置来控制是否上传相关隐私信息。
    </p>
    <h2>
      六、您如何管理自己的信息
    </h2>
    <p>
      （1）您可以在使用我们服务的过程中，访问您提供的注册信息以及访问、修改其他个人信息，也可与我们联系。您访问、修改个人信息的范围和方式将取决于您使用的具体服务。<br>
      &emsp;&emsp;例如，若您在使用邀请好友相关服务时，希望停止分享邀请信息，您可暂停使用该项服务来终止相关的分享服务。<br>
      （2）我们将按照本政策所述，仅为实现我们产品或服务的功能，收集、使用您的信息。<br>
      如您发现我们违反法律、行政法规的规定或者双方的约定收集、使用您的个人信息，您可以要求我们删除。如您发现我们收集、存储的您的个人信息有错误的，您也可以要求我们更正。
      请通过本政策列明的联系方式与我们联系。<br>
      （3）在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。<br>
      （4）请您理解，由于技术所限，以及法律或监管要求，我们可能无法满足您的所有要求，但是如果您有疑义和问题，请联系我们，我们会在合理的期限内答复您的请求。
    </p>
    <h2>
      七、我们分享的信息
    </h2>
    <p>
      &emsp;&emsp;我们遵照法律法规的规定，对信息的分享进行严格的限制，例如：经您事先同意，我们可能与第三方分享您的个人信息<br>
      &emsp;&emsp;仅为实现外部处理的目的，我们可能会与第三方合作伙伴（第三方服务供应商、承包商、代理、广告合作伙伴、应用开发者等，例如，代表我们发出电子邮件或推送通知的通讯服务提供商）（他们可能并非位于您所在的法域）分享您的个人信息，让他们按照我们的说明、隐私政策以及其他相关的保密和安全措施来为我们处理上述信息，并用于以下用途：<br>
      （1）向您提供我们的服务；<br>
      （2）实现“我们如何使用收集的信息”部分所述目的；<br>
      （3）履行我们在《{{ this.$config["Product Name"] }}用户协议》或本政策中的义务和行使我们的权利；<br>
      （4）理解、维护和改善我们的服务。<br>
      &emsp;&emsp;如我们与上述第三方分享您的信息，我们将会采用加密、匿名化处理等手段保障您的信息安全。
      随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向第三方分享您的个人信息时，我们将通过推送通知、公告等形式告知您相关情形，按照法律法规及不低于本政策所要求的标准继续保护或要求新的管理者继续保护您的个人信息。
    </p>
    <h2>
      八、我们可能基于以下目的披露您的个人信息
    </h2>
    <p>
      （1）遵守适用的法律法规等有关规定；<br>
      （2）遵守法院判决、裁定或其他法律程序的规定；<br>
      （3）遵守相关政府机关或其他法定授权组织的要求；<br>
      （4）我们有理由确信需要遵守法律法规等有关规定；<br>
      （5）为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益合理且必要的用途。
    </p>
    <h2>
      九、我们可能向您发送的信息
    </h2>
    <p>
      （1）信息推送<br>
      &emsp;&emsp;您在使用我们的服务时，我们可能向您发送电子邮件、短信、资讯或推送通知。您可以按照我们的相关提示，在设备上选择取消订阅。<br>
      （2）与服务有关的公告<br>
      &emsp;&emsp;我们可能在必要时（例如，因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于广告的公告。
    </p>
    <h2>
      十、存储信息的地点和期限
    </h2>
    <p>
      （1）存储信息的地点<br>
      &emsp;&emsp;我们遵守法律法规的规定，将境内收集的用户个人信息存储于境内。<br>
      （2）存储信息的期限<br>
      &emsp;&emsp;一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：<br>
      &emsp;&emsp;•为遵守适用的法律法规等有关规定；<br>
      &emsp;&emsp;•为遵守法院判决、裁定或其他法律程序的规定；<br>
      &emsp;&emsp;•为遵守相关政府机关或法定授权组织的要求；<br>
      &emsp;&emsp;•我们有理由确信需要遵守法律法规等有关规定；<br>
      &emsp;&emsp;•为执行相关服务协议或本政策、维护社会公共利益，为保护们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。<br>
      &emsp;&emsp;当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。
    </p>
    <h2>
      十一、信息安全
    </h2>
    <p>
      &emsp;&emsp;我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露。<br>
      （1）我们严格遵守法律法规保护用户的通信秘密；<br>
      （2）我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。例如，我们使用加密技术（例如，TLS、SSL）、匿名化处理等手段来保护您的个人信息；<br>
      （3）我们建立专门的管理制度、流程和组织确保信；
    </p>
    <h2>
      十二、联系我们
    </h2>
    <p>
      &emsp;&emsp;如果您有其他的投诉、建议等问题时，都可以通过以下方式和我们取得联系：<br>
      <br>
      &emsp;&emsp;&emsp;&emsp;联系电话：{{ this.$config.Phone }}<br>
      &emsp;&emsp;&emsp;&emsp;邮寄地址：{{ this.$config["Mail address"] }}（收）
    </p>
    <p style="float:right">{{ this.$config["Company Name"] }}</p>
  </div>
</template>

<script>
import marked from 'marked'

export default {
  name: "AboutDeal",
  data() {
    return {
      data: {}
    }
  },
  beforeCreate() {
    document.title = this.$config["Product Name"] + " - 隐私政策"
  },
  mounted() {
    if (this.$config["Html With Markdown"].UserPrivacy) {
      this.markdown()
    }
  },
  methods: {
    markdown() {
      marked.setOptions({
        renderer: new marked.Renderer(),
        gfm: true,
        tables: true,
        breaks: false,
        pedantic: false,
        sanitize: false,
        smartLists: true,
        smartypants: false
      });
    }
  },
  computed: {
    compiledMarkdown() {
      return marked(this.$config["Html With Markdown"].UserPrivacy, {sanitize: true})
    }
  }
}
</script>
